export const SERVICE_GROUP_NAME_REGEX = /^[A-Za-z0-9&*/() -]+$/;
const SERVICE_GROUP_NAME_UNICODE_REGEX = /^[\p{L}0-9&*/() -]+$/u;

export const SERVICE_GROUP_VALIDATION_MESSAGES = {
  required: "Please enter a service group name",
  duplicate: "Duplicate service group name is not allowed",
  minLength: "Service group name must be at least 5 characters",
  maxLength: "Service group name must be 100 characters or fewer",
  invalidCharacters:
    "Service group name can contain only alphabets, numbers, &, *, /, (, ), spaces, and hyphen",
};

export const getLocalizedTitle = (title, lang = "en") => {
  if (!title) return "";
  if (typeof title === "string") return title;
  return title[lang] || title.en || title.vi || "";
};

export const normalizeName = (value) => String(value ?? "").trim().toLowerCase();

export const uniqueById = (items = []) => {
  const seen = new Set();

  return items.filter((item) => {
    const key = item?._id || item?.id || item?.value;
    if (!key) return true;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

export const uniqueByLocalizedTitle = (items = [], lang = "en") => {
  const seen = new Set();

  return uniqueById(items).filter((item) => {
    const titleKey = normalizeName(getLocalizedTitle(item?.title, lang));
    const key = titleKey || item?._id || item?.id || item?.value;
    if (!key) return true;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

export const validateServiceGroupName = (
  value,
  existingServices = [],
  lang = "en",
  options = {}
) => {
  const trimmedValue = String(value ?? "").trim();

  if (!trimmedValue) {
    return SERVICE_GROUP_VALIDATION_MESSAGES.required;
  }

  if (trimmedValue.length < 5) {
    return SERVICE_GROUP_VALIDATION_MESSAGES.minLength;
  }

  if (trimmedValue.length > 100) {
    return SERVICE_GROUP_VALIDATION_MESSAGES.maxLength;
  }

  const allowedCharactersRegex = options.allowUnicodeLetters
    ? SERVICE_GROUP_NAME_UNICODE_REGEX
    : SERVICE_GROUP_NAME_REGEX;

  if (!allowedCharactersRegex.test(trimmedValue)) {
    return SERVICE_GROUP_VALIDATION_MESSAGES.invalidCharacters;
  }

  const normalizedValue = normalizeName(trimmedValue);
  const isDuplicate = existingServices.some((service) => {
    const localizedTitle = getLocalizedTitle(service?.title, lang);
    return normalizeName(localizedTitle) === normalizedValue;
  });

  if (isDuplicate) {
    return SERVICE_GROUP_VALIDATION_MESSAGES.duplicate;
  }

  return "";
};
